export function getURLBody(data: Record<string, string | number>) {
  const params = Object.keys(data).map((field) => [field, `${data[field]}`])
  return new URLSearchParams(params)
}
